import React from "react";
import useScrollReveal from "../hooks/useScrollReveal";
import "../../styles/base/baseline.css";
import "../../styles/pages/services.css";

import "../../styles/module/collaborate.css";
import "../../styles/module/carousel.css";

import WhyUs from "../module/Why-Us";
import API from "../module/API-Slider";
import Collaborate from "../module/Collaborate";
import FAQs from "../module/FAQs";
import Clients from "../module/Clients";

import bg2 from "../../assets/images/img/bg-2.webp";
// import bg3 from "../../assets/images/img/bg-3.svg";
import arrow from "../../assets/images/img/downarrow.webp";

export default function APiIntegration() {
  useScrollReveal("slide-from-left");
  useScrollReveal("slide-from-right");
  useScrollReveal("drop-from-top");
  return (
    <>
      <div className="main-wrapper">
        <img
          alt="scrollDown"
          src={bg2}
          className=" landing__image-background-2 image-background slide-from-left"
        />
        <div
          className="rotated-text"
          onClick={() => (window.location.href = "#scroll")}
        >
          <img src={arrow} alt="downarrow" className="" />
          <h4>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}> scroll down</font>
            </font>
          </h4>
        </div>
        <div className="section section__oferta">
          {/* <img
            className="landing__image-background-1 image-background slide-from-right"
            src={bg3}
            alt="container background"
          /> */}
          <div className="container oferta">
            <h5 className="drop-from-top" id="scroll">
              <font style={{ verticalAlign: "inherit" }}>
                <font style={{ verticalAlign: "inherit" }}>service</font>
              </font>
            </h5>
            <div className="title drop-from-top">
              <h2 style={{ marginBottom: "30px" }}>
                Seamless API & System Integration Tailored to Your Business
                Needs
              </h2>
            </div>
            <div className="description container__text">
              <p className="slide-from-left">
                We connect your existing systems and third-party services
                through custom API integrations designed to streamline
                workflows, improve data flow, and enhance operational
                efficiency. Whether it's linking CRM, payment gateways, or
                analytics tools, we ensure every connection is robust and
                secure.
              </p>
              <p className="slide-from-right">
                Our approach focuses on reliability, scalability, and smooth
                interoperability—making sure your integrated systems work
                flawlessly across platforms. Whether you’re enhancing current
                integrations or building new connections from scratch, we
                deliver solutions that empower your business to operate smarter
                and faster.
              </p>
            </div>
          </div>
        </div>
        <WhyUs hideBackgroundImage={true} />
        <API />
        <Collaborate />
        <FAQs />

        <Clients />
      </div>
    </>
  );
}
